import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import {RadioButton} from "../../modals/types/radiobutton";
import "./radiobutton.scss";

interface IRadioButtons {
    items:RadioButton[]
    value:string
    setValue:React.Dispatch<React.SetStateAction<string>>
}

export default function RadioButtons({items,value,setValue}:IRadioButtons) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
    };
    return (
        <FormControl>
            <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleChange}
            >
                <div style={{marginTop: '-8px', marginRight: '-30px'}}>
                    {
                        items.map((item , index) => {
                            return(
                                <FormControlLabel style={{marginLeft: '10px',fontWeight: '300',fontSize: '12px'}} key={index} value={item.currentValue} control={<Radio/>} label={item.label}/>
                            );
                        })
                    }
                </div>
            </RadioGroup>
        </FormControl>
    );
}